<template>
    <div id="app">
        <Director></Director>
    </div>
</template>

<script>
import { Director } from './components';
export default {
    components: {
        Director
    }
}
</script>

<style>
html, body {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    background: #151515;
}

body {
    position: fixed;
    overflow: hidden;
}

body::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
}

#app {
    width: 100vw;
    height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/App.vue